import React, { useRef, useState } from "react";
import Style from "./PayedReqTabel.module.scss";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, Wallet, XLg } from "react-bootstrap-icons";

const PayedReqTabel = ({ showAddress, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    
    {
      title: "آیدی درخواست",
      dataIndex: "key",
      key: "key",
      width: "10%",
      sorter: (a, b) => a.age - b.age,
    },
    {
      title: " نام کاربری",
      dataIndex: "name",
      key: "name",
      width: "16%",
      ...getColumnSearchProps("name", "نام "),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showAddress(3, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "شماره تلفن",
      dataIndex: "phone",
      key: "phone",
      width: "10%",
      ...getColumnSearchProps("phone", "شماره تلفن"),
    },
    {
      title: "زمان درخواست",
      dataIndex: "date",
      key: "date",
      width: "14%",
    },
    {
      title: "مبلغ واریزی",
      dataIndex: "money",
      key: "money",
      width: "10%",
    },
    {
      title: "شماره پیگیری",
      dataIndex: "track_id",
      key: "track_id",
      width: "10%",
      ...getColumnSearchProps("key", "آیدی پیک "),
    },
    {
      title: "زمان پرداخت",
      dataIndex: "withdraw_date",
      key: "withdraw_date",
      width: "10%",
    },
    
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={data}
        responsive={true}
        scroll={{x:1100, y: 500 }}
      />
    </div>
  );
};

export default PayedReqTabel;
